export const DefaultColors = {
  black: '#000000' as const,
  white: '#ffffff' as const,

  primary100: '#f9f8f8' as const,
  primary200: '#e5e5e5' as const,
  primary300: '#c9c8c8' as const,
  primary400: '#999999' as const,
  primary500: '#808080' as const,
  primary600: '#666666' as const,
  primary700: '#4D4D4D' as const,
  primary800: '#333333' as const,

  black100: '#bab9b9' as const,
  black200: '#a1a0a0' as const,
  black300: '#8d8c8c' as const,
  black400: '#828282' as const,
  black500: '#646464' as const,
  black600: '#505050' as const,
  black700: '#3c3c3c' as const,
  black800: '#282828' as const,

  blue100: '#f3f3fd' as const,
  blue200: '#ddddfa' as const,
  blue300: '#bcbbf5' as const,
  blue400: '#7978eb' as const,
  blue500: '#5857e7' as const,
  blue600: '#4645b8' as const,
  blue700: '#34348a' as const,
  blue800: '#23225c' as const,

  gray100: '#f9f8f8' as const,
  gray200: '#f6f5f5' as const,
  gray300: '#f0efef' as const,
  gray400: '#eae9e9' as const,
  gray500: '#e4e3e3' as const,
  gray600: '#e1e0e0' as const,
  gray700: '#dedddd' as const,
  gray800: '#c9c8c8' as const,

  green100: '#f3f6f5' as const,
  green200: '#dce6e2' as const,
  green300: '#bacec6' as const,
  green400: '#769e8d' as const,
  green500: '#548671' as const,
  green600: '#436b5a' as const,
  green700: '#325043' as const,
  green800: '#21352d' as const,

  orange100: '#fdf7ee' as const,
  orange200: '#fbe8cc' as const,
  orange300: '#f8d199' as const,
  orange400: '#f1a433' as const,
  orange500: '#ee8e00' as const,
  orange600: '#8e7100' as const,
  orange700: '#8e5500' as const,
  orange800: '#5f3800' as const,

  purple100: '#f9f1fc' as const,
  purple200: '#eed5f8' as const,
  purple300: '#ddadf1' as const,
  purple400: '#bb5be4' as const,
  purple500: '#aa32de' as const,
  purple600: '#882881' as const,
  purple700: '#661e85' as const,
  purple800: '#431358' as const,

  red100: '#fbf0f0' as const,
  red200: '#f5d4d2' as const,
  red300: '#ebaaa6' as const,
  red400: '#d7564d' as const,
  red500: '#ce2c21' as const,
  red600: '#a4231a' as const,
  red700: '#7b1a13' as const,
  red800: '#52110d' as const,

  turquoise100: '#f1fcf8' as const,
  turquoise200: '#d6f8f4' as const,
  turquoise300: '#adf1e9' as const,
  turquoise400: '#5be4d4' as const,
  turquoise500: '#2fcc8a' as const,
  turquoise600: '#2681a1' as const,
  turquoise700: '#1e8579' as const,
  turquoise800: '#135850' as const,

  yellow100: '#fdf8e3' as const,
  yellow500: '#c9a227' as const,
}

export type Colors = typeof DefaultColors
